import {Component, ContentChild, inject, Input, OnChanges, SimpleChanges, TemplateRef} from '@angular/core';
import {ActivitiesService} from '@modules/activities/core/activities.service';
import {ActivityGranule, LessonGranuleEntity} from '@modules/activities/core/models';
import {Observable, of} from 'rxjs';

@Component({
    selector: 'app-lesson-horizontal-viewer',
    templateUrl: './lesson-horizontal-viewer.component.html',
    styleUrls: ['./lesson-horizontal-viewer.component.scss'],
    standalone: false
})
export class LessonHorizontalViewerComponent implements OnChanges {
    @Input() lesson!: LessonGranuleEntity;
    @Input() lessonIndex!: number;
    @Input() parentLesson: LessonGranuleEntity;
    @ContentChild('header') headerTemplate: TemplateRef<any>;

    @ContentChild('activity') activityTemplate: TemplateRef<any>;
    private activitiesService = inject(ActivitiesService);

    public activities$: Observable<ActivityGranule[]> = of([]);

    ngOnChanges(_changes: SimpleChanges): void {
        if (this.lesson) {
            this.activities$ = this.activitiesService.loadMultipleActivitiesFromId(this.lesson.get('reference').map(activity => activity.id), false);
        } else {
            this.activities$ = of([]);
        }
    }
}
